// Names the backend resolved for this search — player, team(s), matchup — as
// lowercase relevance terms. The results relevance filter matches item text
// against the typed query; a typo ("bruson") or nickname ("wemby") never
// appears in item text, so without these every result was hidden even though
// the backend had resolved Jalen Brunson / Victor Wembanyama.

const nameOf = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.name || value.fullName || value.player_name || '';
};

export function resolvedRelevanceTerms(responseMetadata) {
    const meta = responseMetadata || {};
    const a = meta._queryClassification?.entities || {};
    const b = meta._queryResolution?.entities || {};
    const names = [
        nameOf(meta._detectedPlayer),
        nameOf(meta._detectedTeam),
        nameOf(meta._homeTeam),
        nameOf(meta._awayTeam),
        nameOf(a.player),
        nameOf(a.team),
        nameOf(b.player),
        nameOf(b.team),
        nameOf(meta._matchup?.team1),
        nameOf(meta._matchup?.team2),
    ].map((n) => String(n).trim().toLowerCase()).filter((n) => n.length >= 3 && n !== 'generic');
    const terms = new Set();
    for (const name of names) {
        terms.add(name);
        const parts = name.split(/\s+/);
        // Last name / nickname ("brunson", "knicks") matches items that carry only part of the name.
        if (parts.length > 1 && parts[parts.length - 1].length >= 4) terms.add(parts[parts.length - 1]);
    }
    return [...terms];
}
